import React from 'react'

import { Grid as BaseGrid, styled } from '@mui/material'
import { DatePicker as DatePickerBase } from '@chilecompra/react-kit/components'

export const Row = styled(({ margin, ...props }) => <BaseGrid container {...props} />)`
  margin: ${props => props.margin || '0 -5px'};
  padding: ${props => props.padding};
  width: 100%;
`

export const Column = styled(({ flexGrow, margin, padding, width, textAlign, ...props }) => (
  <BaseGrid item {...props} />
))`
  margin: ${props => props.margin || '0'};
  padding: ${props => props.padding || '0 5px'};
  width: ${props => props.width};
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.gray[20]};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  padding: 0;
  text-align: center;
`

export const DatePicker = styled(({ className, ...props }) => (
  <DatePickerBase
    {...props}
    PopoverProps={{
      ...props.PopoverProps,
      anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      classes: { ...props.PopoverProps?.classes, paper: className },
      transformOrigin: { horizontal: 'left', vertical: 'top' }
    }}
    variant="inline"
  />
))`
  &.MuiPopover-paper {
    box-shadow: 0 3px 6px ${props => props.theme.palette.gray[0.16]};
  }

  &.MuiPopover-paper .MuiPickersBasePicker-container {
    .MuiPickersToolbar-toolbar {
      background-color: ${props => props.theme.palette.blue[50]};
    }

    .MuiPickersToolbar-toolbar .MuiButtonBase-root:hover {
      background-color: transparent;
    }

    .MuiTypography-subtitle1,
    .MuiTypography-body1 {
      font-size: 16px;
    }

    .MuiTypography-h4 {
      font-size: 34px;
    }

    .MuiTypography-caption {
      font-size: 14px;
    }

    .MuiTypography-body2 {
      font-size: 14px;
    }

    .MuiTypography-h5 {
      font-size: 24px;
    }

    .MuiPickersCalendarHeader-iconButton .MuiSvgIcon-root {
      font-size: 24px;
    }
  }

  &.MuiPopover-paper .MuiPickersDay-day {
    color: ${props => props.theme.palette.gray[20]};
  }

  &.MuiPopover-paper .MuiPickersDay-current {
    color: ${props => props.theme.palette.blue[50]} !important;
  }

  &.MuiPopover-paper .MuiPickersDay-dayDisabled,
  &.MuiPopover-paper .MuiPickersCalendarHeader-dayLabel {
    color: ${props => props.theme.palette.gray[50]};
  }

  &.MuiPopover-paper .MuiPickersDay-daySelected {
    background-color: ${props => props.theme.palette.blue[50]} !important;
    color: ${props => props.theme.palette.brand.white} !important;
  }

  &.MuiPopover-paper .MuiPickersCalendarHeader-transitionContainer .MuiTypography-body1 {
    color: ${props => props.theme.palette.gray[20]};
  }

  &.MuiPopover-paper .MuiPickersCalendarHeader-iconButton {
    color: ${props => props.theme.palette.gray[50]};
  }

  &.MuiPopover-paper .MuiIconButton-root.Mui-disabled {
    color: ${props => props.theme.palette.gray[50]};
  }

  &.MuiPopover-paper .MuiPickersYear-root {
    color: ${props => props.theme.palette.gray[20]};
  }

  &.MuiPopover-paper .MuiPickersYear-yearDisabled {
    color: ${props => props.theme.palette.gray[50]};
  }

  &.MuiPopover-paper .MuiPickersYear-yearSelected {
    color: ${props => props.theme.palette.blue[50]} !important;
  }

  &.MuiPopover-paper .MuiDialogActions-root {
    display: none !important;
  }

  &.MuiPopover-paper .MuiTouchRipple-root {
    display: none;
  }
`
